import baseUrl from "./baseUrl";
import xhr from "xhr";
import { ref } from "vue";
import { DefaultValidationError } from "./types";
import { withCsrfToken } from "./csrfToken";

function request(options: RequestOptions, callback: (err, response) => void | undefined) {
    const requestsInProgress = ref(0);

    if (options.automaticallyRequireLogin === undefined) {
        options.automaticallyRequireLogin = true;
    }

    if (options && options.url) {
        options.url = baseUrl.fixOldV3(options.url);
    }

    if (!options.headers) {
        options.headers = {};
    }
    const send = () => {
        //@ts-expect-error Fix later
        xhr(options, (err, response) => {
            requestsInProgress.value--;

            if (options.automaticallyRequireLogin && response.statusCode === 401) {
                window.location.reload();
                return;
            }

            if (callback) {
                callback(err, response);
            }
        });
    };

    requestsInProgress.value++;

    if ((options.method || "get").toLowerCase() === "get") {
        send();
    } else {
        withCsrfToken(csrfError => {
            if (csrfError) {
                requestsInProgress.value--;
                callback?.(csrfError, undefined);
                return;
            }

            options.headers!["X-Csrf-Token"] = window.panelCsrfToken;
            send();
        });
    }

    return { requestsInProgress };
}

export type HttpResponse<T> = {
    statusCode: number;
    body: T;
    headers: Record<string, string>;
};

export type ValidationHttpError = HttpResponse<{ error: { details: DefaultValidationError[] } }>;

export type RequestOptions = {
    url: string;
    method: string;
    json?: boolean | object;
    automaticallyRequireLogin?: boolean;
    headers?: Record<string, string>;
    body?: object;
};

export type PromiseRequest<T> = (options: RequestOptions) => Promise<HttpResponse<T>>;

export function usePromisedRequest<T>(options: RequestOptions): Promise<HttpResponse<T>> {
    return new Promise((resolve, reject) => {
        request(options, (err, response) => {
            if (err) {
                if (err.statusCode === 0) {
                    err.message = "error.no_connection";
                }
                return reject(err);
            }

            return resolve(response as HttpResponse<T>);
        });
    });
}
